import Spinner from "../Spinner";
import styled from "styled-components";
import { COLOR } from "../../helpers/theme";
import { Link } from "react-router-dom";

const Button = (props: ButtonProps) => {
  const renderLoadingIndicator = () => {
    if (!props.isLoading) return null;
    return (
      <span className="icon">
        <Spinner size="small" />
      </span>
    );
  }

  const renderButtonNormal = () => {
    return (
      <ButtonWrapper noBlock={props.noBlock} disabled={props.disabled}>
        <div className="button" onClick={props.onClick}>
          {renderLoadingIndicator()}
          <span className="caption">{props.caption}</span>
        </div>
      </ButtonWrapper>
    );
  }

  const renderButtonLink = () => {
    return (
      <Link to={props.href ? props.href : '/'}>
        {renderButtonNormal()}
      </Link>
    );
  }

  return props.href ? renderButtonLink() : renderButtonNormal();
}

interface ButtonProps {
  href?: string;
  size?: 'small' | 'medium' | 'large';
  caption: string;
  noBlock?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
}

interface ButtonWrapperProps {
  noBlock?: boolean;
}

const ButtonWrapper = styled.button<ButtonWrapperProps>`
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  background-color: none;

  display: ${(props) =>
    (() => {
      if (props.noBlock) {
        return "inline-block";
      } else {
        return "block";
      }
    })()};
  width: ${(props) =>
    (() => {
      if (props.noBlock) {
        return "auto";
      } else {
        return "100%";
      }
    })()};
  
  & > .button {
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    border-radius: 5px;
    align-items: center;  
    transition: 0.15s all;
    justify-content: center;
    padding: 10px 25px 10px 25px;
    color: #${COLOR.BUTTON_TEXT};
    background: ${COLOR.BUTTON_FACE};
    border: 1px solid ${COLOR.BORDER};

    & > .icon {
      margin-top: 2px;
      margin-right: 4px;
    }

    &:hover {
      color: ${COLOR.PRIMARY};
      background: ${COLOR.BUTTON_FACE_HOVER};
    }
  }
`;

export default Button;